import { sample } from 'effector'
import { entitiesPlayerTrailerModel } from '~/entities/player/trailer'
import * as pinLockFeature from '~/features/pin-lock'

export { entitiesPlayerTrailerModel } from '~/entities/player/trailer'

// Start trailer flow after content is unlocked via PIN
sample({
  clock: pinLockFeature.unlockId,
  source: {
    isFlowActive: entitiesPlayerTrailerModel.$isTrailerFlowActive,
    trailerFlowParams: entitiesPlayerTrailerModel.$trailerFlowParams,
  },
  filter: ({ trailerFlowParams, isFlowActive }, unlockedId) => {
    if (!trailerFlowParams || !isFlowActive) return false
    if (trailerFlowParams.categoryName === 'Banners') return false
    // Check if the unlocked content is the current VOD and has trailer
    return trailerFlowParams.contentId === unlockedId
  },
  fn: ({ trailerFlowParams }) => ({
    ...trailerFlowParams!,
    locked: false,
  }),
  target: entitiesPlayerTrailerModel.initTrailerFlow,
})
